<template>
  <div class="addmanuscript">
    <div v-if="show">
      <div class="body">
        <div class="info" :style="{ left: isCollapsed ? '1.5rem' : '8.25rem' }">
          <manu-inf
            v-if="!isPut"
            :dataInfo="dataInfo"
            ref="manuinfo"
          ></manu-inf>
          <!--          <div class="put" v-if="!isPut" @click="isPut = !isPut">收起</div>-->
          <!--          <div class="open" :style="{ left: isCollapsed ? '-1.5rem' : '-1.5rem' }" v-else @click="isPut = !isPut">-->
          <!--            展开-->
          <!--          </div>-->
        </div>
        <div class="editor" v-if="editorType == 1">
          <!-- 编辑器 -->
          <ritchtext @getVaue="getVaue" ref="ritchtext" />
        </div>
        <div class="editor" style="background: #f6f7fb" v-if="editorType == 2">
          <atlas ref="atla" />
        </div>
        <div class="editor" style="background: #f6f7fb" v-if="editorType == 3">
          <video-img ref="upvideo" />
        </div>
        <div class="editor" style="background: #f6f7fb" v-if="editorType == 4">
          <chain ref="chain" />
        </div>
      </div>
      <footer
        :style="{
          width: isCollapsed ? '100%' : 'calc(100% - 6.75rem)',
          left: isCollapsed ? '0' : '6.75rem',
        }"
      >
        <p class="pnum">正文字数：{{ wordCount }}</p>
        <div class="btn">
          <!--          <div class="draft" @click="team">一键校对</div>-->
          <a-button class="draft" @click="save" :disabled="disabled"
            >保存草稿</a-button
          >
          <a-button class="release" @click="release" :disabled="disabled"
            >发布</a-button
          >
          <!--          <div class="release" @click="release">提交审核</div>-->
        </div>
      </footer>
      <channel-dis
        :dialogVisible.sync="dialogVisible"
        :chainlist="chainlist"
        :content="content"
        :editorType="editorType"
        :paramlist="paramlist"
        :atlaslist="atlaslist"
        :videoimglist="videoimglist"
        @dialog="dialog"
      >
      </channel-dis>
    </div>
    <div v-if="!show">
      <proofreading />
    </div>
  </div>
</template>
<script>
import {
  // createArticle,
  createAtlas,
  atlasSource,
  articleSourceUpdateArticle,
  updateLink,
  updateVideo,
} from "@/api/content";
// import proofreading from '../../../components/proofreading/index.vue'
import proofreading from "../../components/proofreading/index.vue";
import { createArticle, updateArticle } from "@/api/article";
import { mapGetters } from "vuex";
export default {
  components: {
    proofreading,
  },
  data() {
    return {
      disabled: false,
      show: true,
      //渠道分发开关
      dialogVisible: false,
      showfooter: false,
      //稿件信息
      dataInfo: {
        title: "", //标题
        subtitle: "", //副标题
        summary: "", // 摘要
        clickCount: 0, //点击量
        originalTitle: "", //稿件标题
        originalUrl: "", //稿件地址
        // keyword: "", // 关键词
        // label: "", // 标签
        url: "",
        editor: "", // 编辑
        reporter: "", // 记者
        responsibleEditor: "", //责编
        shareDesc: "", // 分享地址
        shareCover: "", // 分享地址
        // isOriginal: 0, //是否原创
        coverType: 0, // 封面类型
        coverUrl: "", //封面地址
      },
      dataInfoFlag: false,
      content: "",
      //侧边栏
      isCollapsed: true,
      editorType: "1",
      isPut: false,
      wpsUrl: "",
      wpsToken: "",
      wpsTimer: null,
      paramlist: {}, //稿件数据
      atlaslist: {}, //图集
      chainlist: {},
      videoimglist: {},
      wordCount: 0,
      articleType: "create",
      articleId: 0, //文章id
    };
  },
  // computed: {
  //   isChildrenCollapsed() {
  //     return this.$store.state.brower.isChildrenCollapsed;
  //   },
  //   ...mapGetters(["userId"]),
  // },
  watch: {
    //   isChildrenCollapsed: {
    //     immediate: true,
    //     handler: function (newval) {
    //       console.log(newval);
    //       this.isCollapsed = newval;
    //     },
    //   },
    editorType(val) {
      this.$refs.manuinfo.dataInfo.summary = "";
      this.$refs.manuinfo.dataInfo.originalTitle = "";
      this.$refs.manuinfo.dataInfo.originalUrl = "";
      // this.$refs.manuinfo.dataInfo.keyword = ''
      // this.$refs.manuinfo.dataInfo.label = ''
      this.$refs.manuinfo.dataInfo.editor = "";
      this.$refs.manuinfo.dataInfo.reporter = "";
      this.$refs.manuinfo.dataInfo.responsibleEditor = "";
      this.$refs.manuinfo.dataInfo.shareDesc = "";
      this.$refs.manuinfo.dataInfo.shareCover = "";
      // this.$refs.manuinfo.dataInfo.isOriginal = 0
    },
    $route: {
      immediate: true,
      handler: function (newval) {
        // console.log(newval, "///////");
      },
    },
  },
  methods: {
    dialog(val) {
      this.dialogVisible = val;
    },
    getVaue(val, wordcount) {
      this.content = val;
      this.wordCount = wordcount;
    },
    //预览
    preview() {
      this.$message.info("正在开发中……");
    },
    //提交审核/发布
    release() {
      if (!this.$refs.manuinfo.dataInfo.subtitle) {
        this.$message.warning("请输入副标题!");
        return false;
      }
      if (!this.$refs.manuinfo.dataInfo.editor) {
        this.$message.warning("请输入编辑!");
        return false;
      }
      if (!this.$refs.ritchtext.dataInfo.title) {
        this.$message.warning("请输入文章标题!");
        return false;
      }
      // if (!this.$refs.ritchtext.dataInfo.coverUrl) {
      //   this.$message.warning("请上传稿件封面!");
      //   return false;
      // }
      // if (this.$refs.manuinfo.dataInfo.isOriginal == 1) {
      //   if (!this.$refs.manuinfo.dataInfo.originalTitle) {
      //     this.$message.warning("请填写稿件来源!");
      //     return false;
      //   }
      //   if (!this.$refs.manuinfo.dataInfo.originalUrl) {
      //     this.$message.warning("请填写稿件地址!");
      //     return false;
      //   }
      // }
      // 判断图文稿
      if (this.editorType == 1) {
        if (!this.$refs.ritchtext.dataInfo.title) {
          this.$message.warning("请填写标题!");
          return false;
        }
        // this.paramlist = {
        //   createInternalUid: JSON.parse(localStorage.getItem("userinfo")).userModel.id,
        //   auditorUid: 0,
        //   docFileUrl: this.content,
        //   editType: 2,
        //   editor: this.$refs.manuinfo.dataInfo.editor, //编辑
        //   keyword: this.$refs.manuinfo.dataInfo.keyword,
        //   label: this.$refs.manuinfo.dataInfo.label,
        //   reporter: this.$refs.manuinfo.dataInfo.reporter,
        //   responsibleEditor: this.$refs.manuinfo.dataInfo.responsibleEditor,
        //   shareCover: this.$refs.manuinfo.dataInfo.shareCover,
        //   shareDesc: this.$refs.manuinfo.dataInfo.shareDesc,
        //   isOriginal: this.$refs.manuinfo.dataInfo.isOriginal,
        //   originalTitle: this.$refs.manuinfo.dataInfo.originalTitle,
        //   originalUrl: this.$refs.manuinfo.dataInfo.originalUrl,
        //   status: 1,
        //   summary: this.$refs.manuinfo.dataInfo.summary,
        //   thumbType: this.$refs.ritchtext.dataInfo.coverType,
        //   thumbUrl: this.$refs.ritchtext.dataInfo.coverUrl,
        //   title: this.$refs.ritchtext.dataInfo.title,
        // }
      }
      // 判断图集
      if (this.editorType == 2) {
        if (!this.$refs.atla.dataInfo.title) {
          this.$message.warning("请填写标题!");
          return false;
        }
        this.atlaslist = {
          createInternalUid: JSON.parse(localStorage.getItem("userinfo"))
            .userModel.id,
          auditorUid: 0,
          editor: this.$refs.manuinfo.dataInfo.editor, //编辑
          keyword: this.$refs.manuinfo.dataInfo.keyword,
          label: this.$refs.manuinfo.dataInfo.label,
          reporter: this.$refs.manuinfo.dataInfo.reporter,
          responsibleEditor: this.$refs.manuinfo.dataInfo.responsibleEditor,
          shareCover: this.$refs.manuinfo.dataInfo.shareCover,
          shareDesc: this.$refs.manuinfo.dataInfo.shareDesc,
          status: 1,
          summary: this.$refs.manuinfo.dataInfo.summary,
          thumbType: this.$refs.atla.dataInfo.coverType,
          thumbUrl: this.$refs.atla.dataInfo.coverUrl,
          title: this.$refs.atla.dataInfo.title,
          isOriginal: this.$refs.manuinfo.dataInfo.isOriginal,
          originalTitle: this.$refs.manuinfo.dataInfo.originalTitle,
          originalUrl: this.$refs.manuinfo.dataInfo.originalUrl,
        };
        this.content = this.$refs.atla.srclist;
      }
      // 判断图集
      if (this.editorType == 3) {
        console.log(this.$refs.upvideo.upshow);
        this.videoimglist = {
          createInternalUid: JSON.parse(localStorage.getItem("userinfo"))
            .userModel.id,
          auditorUid: 0,
          editor: this.$refs.manuinfo.dataInfo.editor, //编辑
          keyword: this.$refs.manuinfo.dataInfo.keyword,
          label: this.$refs.manuinfo.dataInfo.label,
          reporter: this.$refs.manuinfo.dataInfo.reporter,
          responsibleEditor: this.$refs.manuinfo.dataInfo.responsibleEditor,
          shareCover: this.$refs.manuinfo.dataInfo.shareCover,
          shareDesc: this.$refs.manuinfo.dataInfo.shareDesc,
          status: 1,
          summary: this.$refs.manuinfo.dataInfo.summary,
          videoPath: this.$refs.upvideo.dataInfo.videoPath,
          title: this.$refs.upvideo.dataInfo.title,
          videoThumb: this.$refs.upvideo.dataInfo.videoThumb,
          videoDesc: this.$refs.upvideo.dataInfo.videoDesc,
          isOriginal: this.$refs.manuinfo.dataInfo.isOriginal,
          originalTitle: this.$refs.manuinfo.dataInfo.originalTitle,
          originalUrl: this.$refs.manuinfo.dataInfo.originalUrl,
        };
      }
      if (this.editorType == 4) {
        if (!this.$refs.chain.dataInfo.title) {
          this.$message.warning("请填写标题!");
          return false;
        }
        this.chainlist = {
          createInternalUid: JSON.parse(localStorage.getItem("userinfo"))
            .userModel.id,
          auditorUid: 0,
          editor: this.$refs.manuinfo.dataInfo.editor, //编辑
          keyword: this.$refs.manuinfo.dataInfo.keyword,
          label: this.$refs.manuinfo.dataInfo.label,
          reporter: this.$refs.manuinfo.dataInfo.reporter,
          responsibleEditor: this.$refs.manuinfo.dataInfo.responsibleEditor,
          shareCover: this.$refs.manuinfo.dataInfo.shareCover,
          shareDesc: this.$refs.manuinfo.dataInfo.shareDesc,
          status: 1,
          summary: this.$refs.manuinfo.dataInfo.summary,
          thumbType: this.$refs.chain.dataInfo.coverType,
          thumbUrl: this.$refs.chain.dataInfo.coverUrl,
          title: this.$refs.chain.dataInfo.title,
          linkUrl: this.$refs.chain.dataInfo.linkUrl,
          isOriginal: this.$refs.manuinfo.dataInfo.isOriginal,
          originalTitle: this.$refs.manuinfo.dataInfo.originalTitle,
          originalUrl: this.$refs.manuinfo.dataInfo.originalUrl,
        };
      }
      // console.log(this.$refs.ritchtext.dataInfo);
      // console.log(this.$refs.manuinfo.dataInfo);
      // console.log(this.content);
      // console.log(this.params);

      // if (this.$refs.manuinfo.dataInfo.coverType !== 3) {
      //   if (!this.$refs.manuinfo.dataInfo.coverUrl) {
      //     this.$message.warning("请上传封面图!");
      //     return false;
      //   }
      // if (this.$refs.manuinfo.dataInfo.coverType == 1) {
      //   if (this.$refs.manuinfo.dataInfo.coverUrl) {
      //     let coverArry = this.$refs.manuinfo.dataInfo.coverUrl.split(",");
      //     if (coverArry.length < 3) {
      //       this.$message.warning("请继续上传封面图!");
      //       return false;
      //     }
      //   }
      // }
      // }
      // this.dialogVisible = true;
      this.disabled = true;
      if (this.articleType == "create") {
        this.createArticle(1);
      } else {
        this.changeArticle(1);
      }
    },
    //校队
    team() {
      this.show = !this.show;
    },
    //保存草稿
    save() {
      if (!this.$refs.manuinfo.dataInfo.subtitle) {
        this.$message.warning("请输入副标题!");
        return false;
      }
      if (!this.$refs.manuinfo.dataInfo.editor) {
        this.$message.warning("请输入编辑!");
        return false;
      }
      if (!this.$refs.ritchtext.dataInfo.title) {
        this.$message.warning("请输入文章标题!");
        return false;
      }
      // if (!this.$refs.ritchtext.dataInfo.coverUrl) {
      //   this.$message.warning("请上传稿件封面!");
      //   return false;
      // }
      // if (!this.$refs.manuinfo.dataInfo.reporter) {
      //   this.$message.warning("请选择记者!");
      //   return false;
      // }
      // if (this.$refs.manuinfo.dataInfo.isOriginal == 1) {
      //   if (!this.$refs.manuinfo.dataInfo.originalTitle) {
      //     this.$message.warning("请填写稿件来源!");
      //     return false;
      //   }
      //   if (!this.$refs.manuinfo.dataInfo.originalUrl) {
      //     this.$message.warning("请填写稿件地址!");
      //     return false;
      //   }
      // }
      // 判断图文稿
      if (this.editorType == 1) {
        if (!this.$refs.ritchtext.dataInfo.title) {
          this.$message.warning("请填写标题!");
          return false;
        }
      }
      // 判断图集
      if (this.editorType == 2) {
        if (!this.$refs.atla.dataInfo.title) {
          this.$message.warning("请填写标题!");
          return false;
        }
        this.atlaslist = {
          createInternalUid: JSON.parse(localStorage.getItem("userinfo"))
            .userModel.id,
          auditorUid: 0,
          editor: this.$refs.manuinfo.dataInfo.editor, //编辑
          keyword: this.$refs.manuinfo.dataInfo.keyword,
          label: this.$refs.manuinfo.dataInfo.label,
          reporter: this.$refs.manuinfo.dataInfo.reporter,
          responsibleEditor: this.$refs.manuinfo.dataInfo.responsibleEditor,
          shareCover: this.$refs.manuinfo.dataInfo.shareCover,
          shareDesc: this.$refs.manuinfo.dataInfo.shareDesc,
          status: 1,
          summary: this.$refs.manuinfo.dataInfo.summary,
          thumbType: this.$refs.atla.dataInfo.coverType,
          thumbUrl: this.$refs.atla.dataInfo.coverUrl,
          title: this.$refs.atla.dataInfo.title,
        };
        this.content = this.$refs.atla.srclist;
        let params = this.atlaslist;
        console.log(params);
        let publishChannelColumn = "";
        let params2 = encodeURIComponent(JSON.stringify(this.content));
        let params1 = encodeURIComponent(JSON.stringify(publishChannelColumn));
        if (sessionStorage.getItem("manuscript")) {
          let arr = JSON.parse(sessionStorage.getItem("manuscript"));
          delete params.createInternalUid;
          delete params.auditorUid;
          params.id = arr.id;
          (params.lastUpdateInternalUid = JSON.parse(
            localStorage.getItem("userinfo")
          ).userModel.id),
            atlasSource(params1, params2, params).then((res) => {
              if (res.status) {
                this.$message.success(res.message);
                sessionStorage.removeItem("manuscript");
                this.$router.push("draft");
              }
            });
        } else {
          createAtlas(params1, params2, params).then((res) => {
            if (res.status) {
              this.$message.success(res.message);
              this.$router.push("draft");
            }
          });
        }
      }
      // 判断图集
      if (this.editorType == 3) {
        console.log(this.$refs.upvideo.upshow);
        this.videoimglist = {
          createInternalUid: JSON.parse(localStorage.getItem("userinfo"))
            .userModel.id,
          auditorUid: 0,
          editor: this.$refs.manuinfo.dataInfo.editor, //编辑
          keyword: this.$refs.manuinfo.dataInfo.keyword,
          label: this.$refs.manuinfo.dataInfo.label,
          reporter: this.$refs.manuinfo.dataInfo.reporter,
          responsibleEditor: this.$refs.manuinfo.dataInfo.responsibleEditor,
          shareCover: this.$refs.manuinfo.dataInfo.shareCover,
          shareDesc: this.$refs.manuinfo.dataInfo.shareDesc,
          status: 1,
          summary: this.$refs.manuinfo.dataInfo.summary,
          videoPath: this.$refs.upvideo.dataInfo.videoPath,
          title: this.$refs.upvideo.dataInfo.title,
          videoThumb: this.$refs.upvideo.dataInfo.videoThumb,
          videoDesc: this.$refs.upvideo.dataInfo.videoDesc,
        };
        let params = this.videoimglist;
        let publishChannelColumn = "";
        if (sessionStorage.getItem("manuscript")) {
          let arr = JSON.parse(sessionStorage.getItem("manuscript"));
          delete params.createInternalUid;
          delete params.auditorUid;
          params.id = arr.id;
          (params.lastUpdateInternalUid = JSON.parse(
            localStorage.getItem("userinfo")
          ).userModel.id),
            updateVideo(
              encodeURIComponent(JSON.stringify(publishChannelColumn)),
              params
            ).then((res) => {
              if (res.status) {
                this.$message.success(res.message);
                sessionStorage.removeItem("manuscript");
                this.$router.push("draft");
              }
            });
        } else {
          createVideo(
            encodeURIComponent(JSON.stringify(publishChannelColumn)),
            params
          ).then((res) => {
            if (res.status) {
              this.$message.success(res.message);
              this.$router.push("draft");
            }
          });
        }
      }
      if (this.editorType == 4) {
        if (!this.$refs.chain.dataInfo.title) {
          this.$message.warning("请填写标题!");
          return false;
        }
        this.chainlist = {
          createInternalUid: JSON.parse(localStorage.getItem("userinfo"))
            .userModel.id,
          auditorUid: 0,
          editor: this.$refs.manuinfo.dataInfo.editor, //编辑
          keyword: this.$refs.manuinfo.dataInfo.keyword,
          label: this.$refs.manuinfo.dataInfo.label,
          reporter: this.$refs.manuinfo.dataInfo.reporter,
          responsibleEditor: this.$refs.manuinfo.dataInfo.responsibleEditor,
          shareCover: this.$refs.manuinfo.dataInfo.shareCover,
          shareDesc: this.$refs.manuinfo.dataInfo.shareDesc,
          status: 1,
          summary: this.$refs.manuinfo.dataInfo.summary,
          thumbType: this.$refs.chain.dataInfo.coverType,
          thumbUrl: this.$refs.chain.dataInfo.coverUrl,
          title: this.$refs.chain.dataInfo.title,
          linkUrl: this.$refs.chain.dataInfo.linkUrl,
        };
        let params = this.chainlist;
        let publishChannelColumn = "";
        if (sessionStorage.getItem("manuscript")) {
          let arr = JSON.parse(sessionStorage.getItem("manuscript"));
          delete params.createInternalUid;
          delete params.auditorUid;
          params.id = arr.id;
          (params.lastUpdateInternalUid = JSON.parse(
            localStorage.getItem("userinfo")
          ).userModel.id),
            updateLink(
              encodeURIComponent(JSON.stringify(publishChannelColumn)),
              params
            ).then((res) => {
              if (res.status) {
                this.$message.success(res.message);
                sessionStorage.removeItem("manuscript");
                this.$router.push("draft");
              }
            });
        } else {
          createLink(
            encodeURIComponent(JSON.stringify(publishChannelColumn)),
            params
          ).then((res) => {
            if (res.status) {
              this.$message.success(res.message);
              this.$router.push("draft");
            }
          });
        }
      }
      this.disabled = true;
      if (this.articleType == "create") {
        this.createArticle(0);
      } else {
        this.changeArticle(0);
      }
    },
    async getArticleSourceGetInfo(val) {
      let { status, data, message, errors } = await articleSourceGetInfo(val);
      if (status) {
        this.dataInfo = data;
        if (!this.dataInfo.editor) {
          let userinfo = JSON.parse(localStorage.getItem("userinfo"));
          this.dataInfo.editor = userinfo.userModel.likeName;
        }
        this.dataInfoFlag = true;
      }
    },

    /** 接口*/
    //创建文章
    createArticle(status) {
      let subsId = 0;
      if (sessionStorage.getItem("subsId")) {
        subsId = sessionStorage.getItem("subsId");
      }
      let wordCount = this.wordCount;
      let form = {
        auditorUid: 0,
        clickCount: 0,
        // createAt: 0,
        createExternalUid: JSON.parse(localStorage.getItem("userModel")).id,
        createInternalUid: 0,
        docFileName: "",
        docFileSize: 0,
        docFileUrl: this.content,
        docVersion: 0,
        editType: 2,
        editor: this.$refs.manuinfo.dataInfo.editor,
        id: 0,
        intitle: "",
        isDelete: 0,
        isOriginal: 0,
        keyword: this.$refs.manuinfo.dataInfo.keyword,
        label: this.$refs.manuinfo.dataInfo.label,
        lastUpdateExternalUid: JSON.parse(localStorage.getItem("userModel"))
          .id,
        lastUpdateInternalUid: 0,
        originalTitle: this.$refs.manuinfo.dataInfo.originalTitle,
        originalUrl: "",
        reporter: this.$refs.manuinfo.dataInfo.reporter,
        responsibleEditor: this.$refs.manuinfo.dataInfo.responsibleEditor,
        shareCover: this.$refs.manuinfo.dataInfo.shareCover,
        shareDesc: this.$refs.manuinfo.dataInfo.shareDesc,
        clickCount: Number(this.$refs.manuinfo.dataInfo.clickCount),
        status: status,
        subscribeSiteId: subsId ? parseInt(subsId) : 0,
        subtitle: this.$refs.manuinfo.dataInfo.subtitle,
        summary: this.$refs.manuinfo.dataInfo.summary,
        tableName: "",
        thumbType: this.$refs.ritchtext.dataInfo.coverType,
        thumbUrl: this.$refs.ritchtext.dataInfo.coverUrl,
        title: this.$refs.ritchtext.dataInfo.title,
        // updateAt: 0,
        viewCount: 0,
        wordsCount: wordCount,
      };
      // console.log(form)
      createArticle(form).then((res) => {
        if (res.status) {
          this.$message.success(res.message);
          if (status == 0) {
            this.$router.push("drafts");
          } else {
            this.$router.push("released");
          }
          this.disabled = false;
        } else {
          this.disabled = false;
        }
      });
    },
    //修改文章
    changeArticle(status) {
      let subsId = 0;
      if (sessionStorage.getItem("subsId")) {
        subsId = sessionStorage.getItem("subsId");
      }
      let wordCount = this.wordCount;
      let form = {
        docFileUrl: this.content,
        editor: this.$refs.manuinfo.dataInfo.editor,
        id: this.articleId,
        keyword: this.$refs.manuinfo.dataInfo.keyword,
        label: this.$refs.manuinfo.dataInfo.label,
        lastUpdateExternalUid: JSON.parse(localStorage.getItem("userModel"))
          .id,
        editType: 2,
        reporter: this.$refs.manuinfo.dataInfo.reporter,
        responsibleEditor: this.$refs.manuinfo.dataInfo.responsibleEditor,
        shareCover: this.$refs.manuinfo.dataInfo.shareCover,
        shareDesc: this.$refs.manuinfo.dataInfo.shareDesc,
        clickCount: Number(this.$refs.manuinfo.dataInfo.clickCount),
        status: status,
        originalTitle: this.$refs.manuinfo.dataInfo.originalTitle,
        subscribeSiteId: subsId ? parseInt(subsId) : 0,
        subtitle: this.$refs.manuinfo.dataInfo.subtitle,
        summary: this.$refs.manuinfo.dataInfo.summary,
        thumbType: this.$refs.ritchtext.dataInfo.coverType,
        thumbUrl: this.$refs.ritchtext.dataInfo.coverUrl,
        title: this.$refs.ritchtext.dataInfo.title,
        wordsCount: wordCount,
      };
      updateArticle(form).then((res) => {
        if (res.status) {
          this.$message.success(res.message);
          if (status == 0) {
            this.$router.push("drafts");
          } else {
            this.$router.push("released");
          }
        } else {
          this.disabled = false;
        }
      });
    },
  },
  created() {
    // this.dataInfo.editor = JSON.parse(localStorage.getItem('userinfo')).userModel.likeName
  },
  mounted() {
    this.$nextTick(() => {
      if (sessionStorage.getItem("manuscript")) {
        this.articleType = "edit";
        let arr = JSON.parse(sessionStorage.getItem("manuscript"));
        // let arr2 = JSON.parse(sessionStorage.getItem("articleContent"))
        this.articleId = arr.id;
        this.dataInfo.summary = arr.summary; //摘要
        this.dataInfo.subtitle = arr.subtitle; //副标题
        // this.dataInfo.keyword = arr.keyword //关键词
        this.dataInfo.reporter = arr.reporter; //记者
        this.dataInfo.responsibleEditor = arr.responsibleEditor; //责编
        this.dataInfo.shareCover = arr.shareCover; //分享地址
        // this.dataInfo.label = arr.label //关键词
        this.dataInfo.shareDesc = arr.shareDesc; //分享地址
        // console.log(this.$refs.ritchtext);
        // this.$refs.ritchtext.myValue = arr.content //关键词
      } else {
        this.articleType = "create";
      }
      if (sessionStorage.getItem("articleContent")) {
        this.wordCount = JSON.parse(
          sessionStorage.getItem("articleContent")
        ).wordsCount;
      }
      // console.log(this.articleType)
    });
  },
  deactivated() {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
